import { useEffect, useState } from "react";
import { NAV_ITEMS } from "@/mocks/news";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          onClick={() => setOpen(false)}
          className="flex items-center gap-2 whitespace-nowrap"
          aria-label="每日爆料网首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <h1
            className={`font-heading text-xl md:text-2xl font-bold tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            每日爆料
          </h1>
          <span
            className={`ml-1 hidden rounded-full px-2 py-0.5 text-xs font-medium ${
              scrolled
                ? "bg-secondary-100 text-secondary-900"
                : "bg-background-50/20 text-background-50"
            }`}
          >
            线索征集平台
          </span>
        </a>

        <nav
          className="hidden items-center gap-7 lg:flex"
          aria-label="主导航"
        >
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`whitespace-nowrap text-[15px] font-medium transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-background-50/90 hover:text-white"
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-send-plane-line"></i>
            我要爆料
          </a>
        </nav>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-md lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i
            className={`text-2xl ${
              open
                ? "ri-close-line text-foreground-950"
                : scrolled
                  ? "ri-menu-line text-foreground-950"
                  : "ri-menu-line text-background-50"
            }`}
          ></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto flex max-w-7xl flex-col px-4 py-3" aria-label="移动端导航">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-100 py-3 text-[15px] font-medium text-foreground-800 last:border-0"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-3 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600"
            >
              <i className="ri-send-plane-line"></i>
              我要爆料
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}